<template lang="pug">
  Layout
    div.full-width.mt-n12
      div.d-flex.flex-grow
        v-row.header-filter
          v-col(sm=4)
            div.media-date-picker.mt-4
              DateRangePicker(
                :placeholder="$t('table.log.date')",
                :value.sync="dates",
                @update:value="fetch",
              )
          v-col(fluid)
            v-spacer
          v-col(sm=2)
            LimitPicker(
              :value.sync="limit",
              @update:value="fetch",
            )
      v-card.mt-2.full-width
        LogTable(
          ref="LogTable",
          :dates="dates",
          :limit="limit",
          :params="{ type: 'user', type_id: $route.params.id }",
        )
</template>

<script>
import { subDurationFromToday } from '@/utils/time';

import Layout from '@/layouts/User.vue';
import DateRangePicker from '@/components/forms/inputs/DateRangePicker.vue';
import LimitPicker from '@/components/table/LimitPicker.vue';
import LogTable from '@/components/table/LogTable.vue';

export default {
  components: {
    DateRangePicker,
    Layout,
    LimitPicker,
    LogTable,
  },

  data: () => ({
    limit: 10,
    dates: [subDurationFromToday({ days: 10 }), new Date()],
  }),

  methods: {
    fetch() {
      this.$nextTick(() => {
        this.$refs.LogTable.fetch(true);
      });
    },
  },
};
</script>
